<template>
    <div id="scheduled-messages-sent">
        <base-table
            :columns="columns"
            :items="sentList"
            :loading="loading"
            :empty-text="$t('no-messages-in-section')"
            fill
            :fill-offset="88"
        >
            <template #cell(sentAt)="{ item }">
                <div class="cell-datetime">
                    {{ fromUtc(item.attributes.sentAt).date }}
                    {{ fromUtc(item.attributes.sentAt).time }}
                    <timezone></timezone>
                </div>
            </template>
            <template #cell(name)="{ item }">
                {{ item.attributes.name }}
            </template>
            <template #cell(content)="{ item }">
                {{ item.attributes.content }}
            </template>
            <template #cell(audiences)="{ item }">
                <div v-if="item.attributes.audiences == null">{{ $t('all') }}</div>
                <template v-else>
                    <div
                        v-for="(tag, index) in item.attributes.audiences"
                        :key="`${tag}-${index}`"
                        class="d-inline-flex p-0 mr-2 tags"
                    >
                        <p>{{ tag }}</p>
                    </div>
                </template>
                <div class="contact-number"><span>({{ item.attributes.audienceCount }} contacts)</span></div>
            </template>
            <template #cell(actions)="{ item }">
                <button type="button" class="base-table-action" :aria-label="$t('massive-sent-details')" @click="showMassMessageDetails(item.id)">
                    <font-awesome-icon :icon="['fa', 'eye']" />
                </button>
            </template>
        </base-table>
        <b-pagination
            v-if="massScheduledMeta.page && massScheduledMeta.page.total > massScheduledMeta.page['per-page']"
            v-model="page.number"
            :total-rows="massScheduledMeta.page.total"
            :per-page="massScheduledMeta.page['per-page']"
            @input="loadMassMessages"
            align="center"
        ></b-pagination>
        <massive-send-modal :displayMessageDetail="displayMessageDetails"></massive-send-modal>
    </div>
</template>

<script>

import MassiveSendModal     from './SendModal.vue';
import BaseTable            from '@/core/components/BaseTable.vue';
import Timezone             from '@/core/components/Timezone.vue';
import Format               from '@/helpers/Format.js';

// Import external libraries
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        MassiveSendModal,
        BaseTable,
        Timezone
    },
    data () {
        const MASS_CATEGORY = 'mass';

        return {
            MASS_CATEGORY,
            loading:               false,
            displayMessageDetails: false,
            page:                  {
                number: 1,
                size:   25
            },
        };
    },

    computed: {
        ...mapState('core/scheduled-messages', {
            'massMessagesSent':  'sentScheduledMessages',
            'massScheduledMeta': 'sentScheduledMeta'
        }),

        sentList () {
            return Object.values(this.massMessagesSent);
        },

        columns () {
            return [
                {
                    key:     'sentAt',
                    label:   this.$t('sent-date'),
                    thStyle: { width: '20%' }
                },
                {
                    key:     'name',
                    label:   this.$t('sending-name'),
                    thStyle: { width: '16%' },
                    tdClass: 'cell-ellipsis'
                },
                {
                    key:     'content',
                    label:   'Message',
                    thStyle: { width: '28%' },
                    tdClass: 'cell-ellipsis'
                },
                {
                    key:     'audiences',
                    label:   'Audience',
                    thStyle: { width: '24%' }
                },
                {
                    key:     'actions',
                    label:   '',
                    thStyle: { width: '120px' },
                    tdClass: 'cell-actions'
                }
            ];
        }
    },

    mounted () {
        this.loadMassMessages();
    },

    methods: {
        ...mapActions('core/scheduled-messages', {
            index:             'indexSent',
            selectMassMessage: 'select'
        }),

        /**
         * Load planned and not_planned mass messages
         */
        loadMassMessages () {
            this.loading = true;

            // Get list of massive all messages
            this.index({
                'category': this.MASS_CATEGORY,
                page:       this.page
            })
                .then(() => {
                    // Finish loading
                    this.loading = false;
                });
        },

        /**
         * Open the mass message selected detail modal
         */
        showMassMessageDetails (massMessageId) {
            this.selectMassMessage({ id: massMessageId, status: 'sent' })
                .then(() => {
                    this.displayMessageDetails = true;
                    this.$bvModal.show('massive-send-sidebar');
                });
        },

        /**
         * Helper method to format date to use in template
         */
        fromUtc: Format.fromUtc
    }
};
</script>
